export const generateQueryString = params => {
  const queries = []

  if (params.page_size) {
    queries.push(`page_size=${params.page_size}`)
  }
  if (params.orderBy) {
    queries.push(`orderBy=${params.orderBy}`)
  }
  if (params.p) {
    queries.push(`p=${params.p}`)
  }
  if (params.search) {
    queries.push(`search=${params.search}`)
  }
  if (params.action) {
    queries.push(`action=${params.action}`)
  }
  if (params.category) {
    queries.push(`category=${params.category}`)
  }
  if (params.code) {
    queries.push(`code=${params.code}`)
  }
  if (params.stock_code) {
    queries.push(`stock_code=${params.stock_code}`)
  }
  if (params.filter) {
    queries.push(`filter=${params.filter}`)
  }
  if (params.date) {
    queries.push(`date=${params.date}`)
  }
  if (params.stock) {
    queries.push(`stock=${params.stock}`)
  }
  if (params.device) {
    queries.push(`device=${params.device}`)
  }
  if (params.offset) {
    queries.push(`offset=${params.offset}`)
  }
  if (params.val) {
    queries.push(`val=${params.val}`)
  }
  if (params.startDate) {
    queries.push(`startDate=${params.startDate}`)
  }
  if (params.endDate) {
    queries.push(`endDate=${params.endDate}`)
  }
  if (params.profitBy) {
    queries.push(`profitBy=${params.profitBy}`)
  }
  if (params.qa_id) {
    queries.push(`qa_id=${params.qa_id}`)
  }
  if (params.stock_diary_emi_id) {
    queries.push(`stock_diary_emi_id=${params.stock_diary_emi_id}`)
  }
  if (params.stock_diary_user_id) {
    queries.push(`stock_diary_user_id=${params.stock_diary_user_id}`)
  }
  if (params.status) {
    queries.push(`status=${params.status}`)
  }

  queries.push('cache=0')
  const queryString = queries.join('&')
  return queryString
}

export const GenerateQueryV2 = (payload) => {
  const result = Object.entries(payload)
    ?.filter((item) => (typeof item[1] === 'string' && item[1].length > 0) ||
      (typeof item[1] === 'number' && item[1] > 0))
    ?.map((item) => item.join('='))
    ?.join('&')
  return result
}

export const GenerateQueryV3 = (payload) => {
  const result = Object.entries(payload)
    ?.filter((item) => typeof item[1] === 'string')
    ?.filter((item) => item[1].length > 0)
    ?.map((item) => item.join(':'))
    ?.join(',')
  return result
}
